import Vue from 'vue';
import VueTreeNavigation from 'vue-tree-navigation';
import Paginate from 'vuejs-paginate';
import { Input, Icon } from 'element-ui';

import App from './App.vue';
import router from './router';

Vue.use(VueTreeNavigation);
Vue.use(Input);
Vue.use(Icon);

Vue.component('paginate', Paginate);
Vue.config.productionTip = false;

new Vue({
  router,
  data: {
    viewType: null,
    catId: null,
  },
  beforeMount() {
    if (this.$el.attributes['view-type'] && this.$el.attributes['cat-id']) {
      this.viewType = this.$el.attributes['view-type'].value;
      this.catId = this.$el.attributes['cat-id'].value;
    }
  },
  render: h => h(App),
}).$mount('#directory-ui');
